<template>
    <div >
    <b-container>
      <b-row>
        <VerifyMail class="marginal"/>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import VerifyMail from '@/components/VerifyMail.vue';
export default {
  name: 'verifymail',
  components: {
    VerifyMail
  }
}
</script>